<style lang="scss" scoped>
  .ivu-select-selection{
    display: flex;
    justify-content: flex-start;
  }
  .event-icon{
    font-size: 16px;
    line-height: 30px;
    color: #657180;
    padding-left: 5px;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
    padding-left: 4px;
  }
  .ivu-select-selection .ivu-select-arrow:nth-of-type(1) {
    display: inline-block;
  }
  .ivu-select-visible .ivu-select-arrow:nth-of-type(1) {
    transform: rotate(180deg);
  }
  .choose-box .ivu-input, .choose-box .ivu-input:focus, .choose-box .ivu-input:hover{
    border: none;
    box-shadow: none;
  }
  .ivu-select-dropdown-list .ivu-select-item{
    .iconfont{
      font-size: 16px;
      vertical-align: middle;
      color: #657180;
      margin-right: 2px;
    }
    span{
      vertical-align: middle;
    }
  }
</style>
<template>
  <div
    :class="['ivu-select', 'ivu-select-single', {'ivu-select-visible': showMenu}]"
    v-clickoutside="handleClose"
  >
    <div @click="showDropDown" class="ivu-select-selection">
      <i
        v-for="iconItem in curPlatform"
        v-if="platformInfo[iconItem]"
        :key="iconItem"
        :class="['event-icon', 'iconfont', platformInfo[iconItem].icon]"
      ></i>
      <Input
        class="ivu-select-selected-value"
        v-model="inputModel"
        :title="inputModel"
        @on-change="searchList"
        @on-blur="closeDropDown"
        :placeholder="$t(`${typeName[callerType]}.choose`)"
      ></Input>
      <i class="ivu-icon ivu-icon-md-arrow-dropdown ivu-select-arrow"></i>
    </div>
    <transition name="slide-up">
      <div v-show="showMenu" class="ivu-select-dropdown"  x-placement="bottom">
        <ul class="ivu-select-not-found" v-show="!listInLoad && !showList.length">
          <li>{{ $t('userGroupEvent.noData') }}</li>
        </ul>
        <ul class="ivu-select-dropdown-list" v-show="!listInLoad && showList.length">
          <li
            v-for="(item, index) in showList"
            :class="['ivu-select-item', {'ivu-select-item-selected': item.value === selectName}]"
            @click="selectCon(item.value, item.label, item.platformid)"
            :title="item.label"
            :key="item.value"
          >
            <i
              v-for="iconItem in item.platformid"
              v-if="platformInfo[iconItem]"
              :key="iconItem"
              :class="['iconfont', platformInfo[iconItem].icon]"
            ></i>
            <span>{{ item.label }}</span>
          </li>
        </ul>

        <ul v-show="listInLoad" class="ivu-select-loading">{{ $t('userGroupEvent.loading') }}</ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { directive as clickoutside } from 'v-click-outside-x';

export default {
  props: {
    callerType: String,
    typeName: {
      type: Object,
      default() {
        return {};
      },
    },
    selectName: String,
    selectList: {
      type: Array,
      default() {
        return [];
      },
    },
    listInLoad: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  directives: {
    clickoutside,
  },
  data() {
    return {
      inputModel: '',
      showMenu: false,
      showList: this.selectList,
      curPlatform: [],
      platformInfo: {
        1: {
          value: 1,
          name: 'android',
          icon: 'icon-android-r',
        },
        2: {
          value: 2,
          name: 'ios',
          icon: 'icon-iOS-r',
        },
        4: {
          value: 4,
          name: 'windows',
          icon: 'icon-windows-r',
        },
        16: {
          value: 16,
          name: 'html5',
          icon: 'icon-html-r',
        },
        32: {
          value: 32,
          name: 'weichat',
          icon: 'icon-miniprogram-r',
        },
        64: {
          value: 64,
          name: 'quickapp',
          icon: 'icon-kuaiyingyongSDK',
        },
      },
    };
  },
  computed: {
    eventModel: {
      get() {
        const selectList = this.selectList;
        let label = '';
        let platformid = [];

        for (let i = 0, len = selectList.length; i < len; i += 1) {
          const item = selectList[i];
          if (item.value === this.selectName) {
            label = selectList[i].label;
            platformid = selectList[i].platformid || [];
            break;
          }
        }
        // 处理恢复赋值
        this.inputModel = label;
        this.curPlatform = platformid;
        return {
          label,
          platformid,
        };
      },
      set() {

      },
    },
  },
  watch: {
    eventModel(val) {
      // 处理初次赋值
      this.inputModel = val.label;
      this.curPlatform = val.platformid;
    },
    selectList(val) {
      this.showList = val;
    },
  },
  monuted() {
  },
  methods: {
    showDropDown() {
      this.showMenu = true;
    },
    closeDropDown() {
      this.showMenu = false;
    },
    selectCon(id, name, platformid) {
      this.eventModel = {
        label: name,
        platformid,
      };
      // 恢复显示所有数据
      this.showList = this.selectList;
      this.showMenu = false;

      // 数据修改派发编译事件
      this.$emit('select-id', id, name);
    },
    handleClose() {
      this.showMenu = false;
    },
    searchList() {
      const selectList = this.selectList;
      const q = this.inputModel;

      this.showList = [];
      selectList.forEach((item) => {
        if (item.label.indexOf(q) > -1) {
          this.showList.push(item);
        }
      });
    },
  },
};
</script>
